<script setup lang="ts">
    import type { SbBlokData } from '@storyblok/js';

    const props = defineProps<{
        blok: ATextIconComponentStoryblok;
    }>();

    const iconName = computed(() => {
        if (typeof props.blok.icon !== 'string') {
            return '';
        }

        const icon = props.blok.icon.trim();

        if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(icon)) {
            return '';
        }

        return `lucide:${icon}`;
    });
</script>

<template>
    <div
        v-editable="props.blok"
        class="text-icon-wrapper"
    >
        <div
            v-if="iconName"
            class="text-icon"
            aria-hidden="true"
        >
            <Icon
                :name="iconName"
                class="text-icon__icon"
                :class="blok.iconColor ? `--${blok.iconColor}` : ''"
            />
        </div>

        <StoryblokComponentWrapper
            v-for="entry in props.blok?.text"
            :key="entry?._uid"
            :blok="entry as unknown as SbBlokData"
        />
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/text-icon/text-icon.scss';
</style>
